import axios from 'axios';
import config from '../config';

export const sendAgentQuery = async (query) => {
    try {
        // Get user data from localStorage
        const userData = JSON.parse(localStorage.getItem('userData'));
        if (!userData) {
            throw new Error('User not logged in');
        }

        const response = await axios.post(
            `${config.API_URL}/agent`,
            { 
                query,
                username: userData.username
            },
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
        return response.data;
    } catch (error) {
        throw error.response?.data || { error: 'Failed to send query' };
    }
}; 